// extracted by mini-css-extract-plugin
export var inputContainer = "_om-0";